import React from "react"
import { Table, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableBody } from "material-ui"
import strings from "../../localization/strings"
import moment from "moment"
import { EAuditTypes, EPunchAuditAction, IPunchAudit } from "../../models"
import * as timeHelper from "../../helpers/timeHelper"
import ClientLocalDateTimeStr from "../common/ClientLocalDateTimeStr"

interface IProps {
    audits: IPunchAudit[]
    hierarchyId: string
    jobId: string
}

const AuditTable: React.SFC<IProps> = (props: IProps) => {
    const getTimeStr = (dateTime: string) => {
        return moment(timeHelper.keepConvertUTCToLocal(dateTime)).format("hh:mm a")
    }
    const getDateStr = (dateTime: string) => {
        return moment(timeHelper.keepConvertUTCToLocal(dateTime)).format("MMM DD, YYYY")
    }

    return (
        <div>
            <b>{props.audits.find(i => i.AuditType === EAuditTypes.Punch) ? strings.Punch_Audit_Records : strings.Expense_Audit_Records}</b>
            <Table
                multiSelectable={false}
                selectable={false}
                bodyStyle={{ maxHeight: 400, overflowY: "visible" }}
            >
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.actionCol}>{strings.Action}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.dateCol}>{strings.Change_Date}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.noteCol}>{strings.Note}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={false} deselectOnClickaway={true} stripedRows={true} displayRowCheckbox={false}>
                    {props.audits && props.audits.length > 0 &&
                        props.audits.map((row, i) => {
                            let action = row.AuditType === EAuditTypes.Punch
                                ? strings.Add
                                : row.AuditType === EAuditTypes.Expense
                                    ? strings.Add_Expense
                                    : strings.Add_PPA_Expense
                            if (row.PunchAuditAction === 1) {
                                action = row.AuditType === EAuditTypes.Punch
                                    ? strings.Update
                                    : row.AuditType === EAuditTypes.Expense
                                        ? strings.Update_Expense
                                        : strings.Update_PPA_Expense
                            }
                            else if (row.PunchAuditAction === 2) {
                                action = row.AuditType === EAuditTypes.Punch
                                    ? strings.Delete
                                    : row.AuditType === EAuditTypes.Expense
                                        ? strings.Delete_Expense
                                        : strings.Delete_PPA_Expense
                            }
                            else if (row.PunchAuditAction === 3) {
                                action = strings.Auto_Break
                            }
                            else if (row.PunchAuditAction === 4) {
                                action = strings.Rounded
                            }
                            else if (row.PunchAuditAction === 5) {
                                action = strings.AutoTransfer
                            }
                            else if (row.PunchAuditAction === 6) {
                                action = strings.Error
                            }
                            else if (row.PunchAuditAction === 7) {
                                action = strings.AutoSplitOnDayBoundry
                            }
                            else if (row.PunchAuditAction === 8) {
                                action = strings.Exported
                            }
                            else if (row.PunchAuditAction === 9) {
                                action = strings.ExportFailed
                            }
                            else if (row.PunchAuditAction === 10) {
                                action = strings.SkipExport
                            }
                            else if (row.PunchAuditAction === 11) {
                                action = strings.TimecardSequenceError
                            }
                            else if (row.PunchAuditAction === 12) {
                                action = strings.MobileLog
                            }
                            else if (row.PunchAuditAction === 13) {
                                action = strings.Custom_Rounded
                            }
                            else if (row.PunchAuditAction === 14) {
                                action = strings.Add_Missing_Punch
                            }
                            else if (row.PunchAuditAction === 15) {
                                action = strings.Accept_Suspense_Punch
                            }
                            else if (row.PunchAuditAction === 16) {
                                action = strings.Suspense_Time
                            }
                            else if (row.PunchAuditAction === 17) {
                                action = strings.Reject_Suspense
                            }
                            else if (row.PunchAuditAction === 18) {
                                action = strings.Time_Fraud
                            }
                            else if (row.PunchAuditAction === 19) {
                                action = strings.Adjusted
                            }
                            else if (row.PunchAuditAction === 20) {
                                action = strings.IVR_Call
                            }
                            const note = row.PunchAuditAction === EPunchAuditAction.Add ?
                                row.AuditType === EAuditTypes.Punch ?
                                    `New punch added at ${getTimeStr(row.ChangedLocalDateTime)} ${(row.Note.includes("[via mobile supervisor services.]") ? "[via mobile supervisor services.]":"")}` :
                                    row.AuditType === EAuditTypes.Expense ?
                                        `New expense added to ${getDateStr(row.ChangedLocalDateTime)}` :
                                        `New PPA expense added to ${getDateStr(row.ChangedLocalDateTime)}` :
                                row.Note.includes("Time edit") ?
                                    row.AuditType === EAuditTypes.Punch ?
                                        `Time was changed from ${getDateStr(row.PreviousLocalDateTime)} ${getTimeStr(row.PreviousLocalDateTime)} to ${getDateStr(row.ChangedLocalDateTime)} ${getTimeStr(row.ChangedLocalDateTime)} ${(row.Note.includes("[via mobile supervisor services.]") ? "[via mobile supervisor services.]":"")}` :                                        
                                        `PayDate was changed from ${getDateStr(row.PreviousLocalDateTime)} to ${getDateStr(row.ChangedLocalDateTime)} ${(row.Note.includes("[via mobile supervisor services.]") ? "[via mobile supervisor services.]":"")}` :
                                    row.Note
                            return (
                                <TableRow key={`row-${i}`}>
                                    <TableRowColumn style={styles.nameCol} title={row.ChangeUserName}>
                                        {row.ChangeUserName}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.actionCol} title={action}>{action}</TableRowColumn>
                                    <TableRowColumn style={styles.dateCol}>
                                        <ClientLocalDateTimeStr
                                            hierarchyId={props.hierarchyId}
                                            jobId={props.jobId}
                                            utcTime={row.ActionDateTime}
                                            formatStr="llll"
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.noteCol}>
                                        <div dangerouslySetInnerHTML={{ __html: note }} />
                                    </TableRowColumn>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </div>
    )
}

export default AuditTable

const styles = {
    nameCol: {
        cursor: "pointer",
        paddingLeft: 10,
        paddingRight: 10,
        width: 85
    },
    actionCol: {
        cursor: "pointer",
        paddingLeft: 10,
        paddingRight: 10,
        width: 125
    },
    dateCol: {
        cursor: "pointer",
        paddingLeft: 10,
        paddingRight: 10,
        width: 160
    },
    noteCol: {
        cursor: "pointer",
        paddingLeft: 10,
        paddingRight: 10,
        whiteSpace: "normal",
        wordWrap: "break-word",
    }
}
